/** Paleta para gráficos pizza na Diretoria (9+ fatias). */
export const DIRETORIA_PIE_COLORS = [
  '#0f172a',
  '#ca8a04',
  '#2563eb',
  '#16a34a',
  '#9333ea',
  '#ea580c',
  '#db2777',
  '#0891b2',
  '#4d7c0f',
  '#7c3aed',
  '#b45309',
];
